import React from 'react';
import ReactModal from 'react-modal';

import { HookForm } from '../../validation/HForm';
import { DepartmentModalAdd } from '../utilites/Forms';
import { Message } from '../utilites';

import CrossIcon from '../../assets/icons/cross.svg';
import createCashBoxScheme from "../../validation/scheme/cashBoxScheme";
import {useSelector} from "react-redux";

const DepartmentEditModal = ({ cashBox, onSubmit, isOpen, onClick, error, handleBack }) => {
  const { accessFeatures } = useSelector(({ user }) => user);

  const defaultData = {
    name: cashBox.name,
    number: cashBox.number,
    phone: cashBox.phone,
    mobilePhone: cashBox.mobilePhone ? cashBox.mobilePhone : '',
    city: cashBox.city,
    street: cashBox.street,
    house: cashBox.house,
    building: cashBox.building,
    office: cashBox.office,
    leaderId: {
      label: cashBox.leader.fullName,
      value: cashBox.leader.id,
    },
    chiefAccountantId: {
      label: cashBox.chiefAccountant.fullName,
      value: cashBox.chiefAccountant.id,
    },
    accountantId: {
      label: cashBox.accountant.fullName,
      value: cashBox.accountant.id,
    },
    seniorCommodityExpertId: {
      label: cashBox.seniorCommodityExpert.fullName,
      value: cashBox.seniorCommodityExpert.id,
    },
    goodsSpecialistsIds: cashBox?.goodsSpecialists
      ? cashBox.goodsSpecialists.map((i) => ({
          label: i?.fullName,
          value: i?.id,
        }))
      : [{ label: '', value: '' }],
    additionalInfo: cashBox.additionalInfo,
  };

  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel="Modal"
      className="modal-container overflow-modal"
      overlayClassName="modal-overlay">
      <HookForm onSubmit={onSubmit} 
                validationSchema={createCashBoxScheme(accessFeatures["cashboxNameTypeOne"], accessFeatures["cashbox.mobile"], accessFeatures['cash_box.main.enable'])}
                defaultValues={defaultData}
                submitOnEnterPress = {true}>
        <div className="modal-header">
          <h2>Редактирование подразделения</h2>
          <button className="button-icontrigger modal-closetrigger" onClick={onClick}>
            <span className="icon">
              <CrossIcon />
            </span>
          </button>
        </div>
        <div className="modal-body">
          {error && <Message type="error" text={error} />}
          <DepartmentModalAdd mobilePhone={cashBox.mobilePhone} name={cashBox.name} h={true} isMain={cashBox.isMain} autoCashBox={cashBox.autoCashBox} />
        </div>
        <div className="modal-footer">
          <button className="button">Сохранить</button>
          <button className="button-light" onClick={handleBack}>
            Отменить
          </button>
        </div>
      </HookForm>
    </ReactModal>
  );
};

export default DepartmentEditModal;
